import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootRedux from './duck';

const persistedReducer = persistReducer(
  {
    key: 'root',
    storage,
    blacklist: [
      'checkout',
      'filterSearch',
      'hotelDetails',
      'generics',
      'mapHotel',
      'results',
      'search',
      'user',
      'userReservationsList',
    ],
  },
  combineReducers(rootRedux),
);

export const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
